/**
 * PostHog was removed from sphinx. This module keeps only the non-telemetry
 * helpers that other code still imports (URL scrubbing for error screens and
 * the standard event-prop shape used by legacy call sites).
 */

/**
 * A score result link is a bearer credential — the token in `/results/<token>`
 * is the only thing standing between a private run and anyone who has the URL.
 * Replace the token with a placeholder before anything is displayed or logged.
 */
export function scrubSensitiveUrl(value: string): string {
  return value.replace(/(\/results\/)[^/?#]+/g, "$1[redacted]");
}

export function detectPlatform() {
  return "npm";
}

export function detectEnvironment() {
  return import.meta.env.VITE_ENVIRONMENT;
}

export function standardEventProps(location: string): {
  location: string;
  platform: string;
  environment?: string;
} {
  const environment = detectEnvironment();
  return {
    location,
    platform: detectPlatform(),
    ...(environment !== undefined ? { environment } : {}),
  };
}
